var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",on:{"click":_vm.editData}},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-pen"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }